<template>
  <exo-help-dialog title="Solar flux">
    The value of the solar flux <katex-element expression="F_{10.7}" /> is
    correlated to the atmospheric density. As a rule of thumb, increasing the
    solar flux increases the density. For instance:
    <br />
    <ul>
      <li>
        solar flux 65 corresponds to low solar activity and minimum density;
      </li>
      <li>solar flux 150 is an average value;</li>
      <li>
        solar flux 275 corresponds to strong solar activity and maximum density.
      </li>
    </ul>
  </exo-help-dialog>
</template>

<script>
export default {
  name: 'tooltipCustomSolarFlux'
}
</script>
